import React, { Component, Fragment } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import { Prefetch } from '../../../store/app'
import { Articles } from 'ion-article-cmp'
import HomePageMeta from '../../components/HomePageMeta'
import Ad from '../../components/Ad'
import WingBanners from '../../components/WingBanners'
import FORMATS from '../../components/AdFormats'
import NoImage from '../../static/no-image.png'
import HomePageTemplate from '../../templates/Articles/HomePageHighlight'
import SiteSidebar from '../../components/Sidebar'
import logo from '../../static/general/house-and-garden.svg'
import { DesktopTablet, MobileElse } from 'ion-media'
import MagazineCover from '../../components/MagazineCover'

export class HomePage extends Component {
  constructor (props) {
    super(props)
    // Don't call this.setState() here!
    this.state = { isEmpty: true, is600: false, hasMounted: false }
  }

  componentDidMount () {
    // Don't prefetch at this stage
    // this.props.Prefetch()
    this.setState({ hasMounted: true })
  }

  render () {
    return (
      <>
        <WingBanners useSmall={this.props.useSmall} isConnected={this.props.isConnected} location={this.props.location} onSlotRenderEndedLeft={this.props.onSlotRenderEndedLeft} onSlotRenderEndedRight={this.props.onSlotRenderEndedRight} />
        <Helmet title={process.env.RAZZLE_SITE_TITLE}>
          <meta property='og:url' content={process.env.RAZZLE_SITE_URL} />
          <meta name='description' content={process.env.RAZZLE_SITE_DESCRIPTION} />
          <meta itemProp='description' content={process.env.RAZZLE_SITE_DESCRIPTION} />
          <meta property='og:description' content={process.env.RAZZLE_SITE_DESCRIPTION} />
          <meta name='twitter:site' content={process.env.RAZZLE_SITE_TWITTER} />
          <meta name='twitter:creator' content={process.env.RAZZLE_SITE_TWITTER} />
          <meta name='twitter:description' content={process.env.RAZZLE_SITE_DESCRIPTION} />
          <meta name='twitter:title' content={process.env.RAZZLE_SITE_TITLE} />
          <meta name='twitter:card' content='summary_large_image' />
          <meta name='twitter:image:src' content={logo} />
        </Helmet>
        <HomePageMeta {...this.props} />
        <span>
          <Ad isConnected={this.props.isConnected} path={`/${process.env.RAZZLE_DFP_CODE}/homepage`} slotId='leaderboard-1' targeting={{ leaderboard: '1' }} collapseEmptyDiv className='advert-leaderboard-1' {...FORMATS.leaderboard} />
        </span>
        <div className='wrapper article-listing' ref={this.setStickyRef}>
          <Articles {...this.props} component={HomePageTemplate} section='all-content-feed' count={18} pageSize={18} noImage={NoImage} withMore />
          <SiteSidebar {...this.props} section='homepage' sticky={this.state.sticky}>
            <div>
              {this.state.hasMounted &&
                <DesktopTablet>
                  <MagazineCover />
                </DesktopTablet>}
            </div>
          </SiteSidebar>
        </div>
        {this.state.hasMounted &&
          <MobileElse>
            <Ad isConnected={this.props.isConnected} path={`/${process.env.RAZZLE_DFP_CODE}/homepage`} slotId='leaderboard-3' targeting={{ leaderboard: '3' }} collapseEmptyDiv className='advert-leaderboard-3' {...FORMATS.leaderboard} />
          </MobileElse>}
      </>
    )
  }
}

const mapStateToProps = (state) => ({ articles: state.articles })
const mapDispatchToProps = (dispatch) => bindActionCreators({ Prefetch }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(HomePage)
